var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"main-header"},[_c('el-header',[_vm._v("m7g 差分更新 海外用ツール")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }